import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FaPencilAlt as PencilIcon } from 'react-icons/fa';

import { confirmModalDataPropTypes } from '../propTypes';

class EditUserSettingsCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    showUserSettingsFormForEdit: PropTypes.func.isRequired,
    addingNewUser: PropTypes.bool.isRequired,
    placeholderForNewUser: PropTypes.string.isRequired,
    loggedInUserSso: PropTypes.string.isRequired,
    canEditHimself: PropTypes.bool.isRequired,
    canEditUsers: PropTypes.bool.isRequired,
    isUserModified: PropTypes.bool.isRequired,
    confirmModalData: confirmModalDataPropTypes,
    showConfirmDialogModal: PropTypes.func.isRequired,
    hideConfirmDialogModal: PropTypes.func.isRequired,
    userToEditSso: PropTypes.string,
    readOnly: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    userToEditSso: '',
  };

  showUserSettingsFormForEdit = () => {
    const {
      confirmModalData,
      value,
      showUserSettingsFormForEdit,
      hideConfirmDialogModal,
    } = this.props;

    showUserSettingsFormForEdit(value);

    if (confirmModalData && confirmModalData.show) {
      hideConfirmDialogModal();
    }
  };

  onClickHandler = () => {
    const {
      isUserModified,
      readOnly,
      userToEditSso,
      value,
      showConfirmDialogModal,
    } = this.props;

    if (userToEditSso === value && !readOnly) {
      return;
    }
    if (!isUserModified) {
      return this.showUserSettingsFormForEdit();
    }

    showConfirmDialogModal({
      onConfirm: this.showUserSettingsFormForEdit,
    });
  };

  render() {
    const {
      value,
      addingNewUser,
      placeholderForNewUser,
      loggedInUserSso,
      canEditHimself,
      canEditUsers,
    } = this.props;

    const isRenderingOnNewUserRow = addingNewUser && !value.length;
    if (isRenderingOnNewUserRow) {
      return <div>{placeholderForNewUser}</div>;
    }

    if (!canEditUsers || (value.length && (value === loggedInUserSso) && !canEditHimself)) {
      return null;
    }

    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit User Settings"
          onClick={this.onClickHandler}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default EditUserSettingsCellRenderer;
